import { render, staticRenderFns } from "./section-slider.vue?vue&type=template&id=792a3126&scoped=true"
import script from "./section-slider.vue?vue&type=script&lang=js"
export * from "./section-slider.vue?vue&type=script&lang=js"
import style0 from "./section-slider.vue?vue&type=style&index=0&id=792a3126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792a3126",
  null
  
)

export default component.exports